import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChangeOrdersRequestService implements OnDestroy {

  search: Subject<any> = new Subject();
  sort: Subject<{ column: string | null; direction: 'asc' | 'desc' }> = new Subject();

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor() {

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }


}
